module.exports = __webpack_public_path__ + "img/log.e93dfe05.svg";